var _style, _rect, _g, _g2, _line, _path, _g3, _line2, _ellipse, _rect2, _rect3, _g4, _g5, _g6, _g7, _circle, _g8, _line3, _line4, _line5, _line6, _line7, _line8, _rect4, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _g9, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#CECECE;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#00354C;}\n\t.st3{fill:none;stroke:#00354C;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#D1D1D1;}\n\t.st5{fill:#01D392;}\n\t.st6{fill:#F7BF46;}\n\t.st7{opacity:0.68;fill:none;stroke:#F7BF46;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#00354C;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#00354C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#F6F6F4;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_26_",
    className: "st0",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st1",
    d: "M455.7,501.5l139,114.2c6.9,5.7,16.9,5.7,23.8,0v0c9.1-7.5,9.1-21.5,0-28.9l-150-123.2 c-7.4-6.1-18.1-6.1-25.6,0L293,586.7c-9.1,7.5-9.1,21.5,0,28.9l0,0c6.9,5.7,16.9,5.7,23.8,0L455.7,501.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    className: "st1",
    points: "455.7,501.5 341.5,595.3 351.4,784.4 560.1,784.4 569.9,595.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M455.7,623.2L455.7,623.2c-40.7,0-72.6,27.3-71.4,60l3.8,101.2h135.2l3.8-101.2 C528.3,650.5,496.4,623.2,455.7,623.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M435,590c1.9,4.4,7,6.4,11.4,4.6c2.8-1.1,6-1.8,9.3-1.8s6.5,0.6,9.3,1.8 c4.4,1.8,9.5-0.2,11.4-4.6c0.9-2.1,1.4-4.4,1.4-6.7c0-10.6-9.9-19.1-22.2-19.1s-22.2,8.6-22.2,19.1C433.6,585.7,434,587.9,435,590z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_42_",
    transform: "matrix(0.7866 -0.6174 0.6174 0.7866 -251.5098 383.4871)",
    className: "st1",
    cx: 429.1,
    cy: 555.6,
    rx: 7.8,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_34_",
    className: "st1",
    cx: 455.7,
    cy: 546.6,
    rx: 10.2,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_39_",
    transform: "matrix(0.6174 -0.7866 0.7866 0.6174 -255.5751 591.1545)",
    className: "st1",
    cx: 480,
    cy: 558.3,
    rx: 6.6,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,959.2c0,2.5-1.2,3.7-2.6,3.7c-1.1,0-1.9-0.5-2.1-1.4c-0.4,0.5-1,0.8-1.8,0.8c-1.5,0-2.6-1.2-2.6-2.8 c0-1.6,1.1-2.8,2.6-2.8c0.7,0,1.2,0.3,1.6,0.7v-0.5h1.6v3.9c0,0.8,0.3,1.4,1,1.4c0.9,0,1.7-0.9,1.7-3c0-3-2.3-5.3-5.4-5.3 c-3.1,0-5.6,2.4-5.6,5.7c0,3.3,2.5,5.7,5.9,5.7c1.1,0,2.1-0.2,2.9-0.4v0.6c-0.8,0.3-1.7,0.4-2.9,0.4c-3.7,0-6.5-2.6-6.5-6.2 c0-3.4,2.7-6.2,6.2-6.2C61.1,953.3,63.2,956.4,63.2,959.2z M58.3,959.5c0-0.8-0.6-1.4-1.3-1.4c-0.8,0-1.3,0.5-1.3,1.4 c0,0.8,0.6,1.3,1.3,1.3C57.8,960.9,58.3,960.3,58.3,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.4,955.1v2c-1.2-0.1-2.6,0.5-2.6,2.4v4.3h-1.9v-8.6h1.9v1.4C67.3,955.5,68.3,955.1,69.4,955.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.6,962.3c1,0,1.8-0.5,2.2-1.1l1.5,0.9c-0.8,1.2-2.1,1.9-3.8,1.9c-2.8,0-4.7-1.9-4.7-4.5 c0-2.5,1.8-4.5,4.5-4.5c2.6,0,4.3,2.1,4.3,4.5c0,0.3,0,0.5-0.1,0.8h-6.8C72.1,961.6,73.2,962.3,74.6,962.3z M76.9,958.8 c-0.3-1.5-1.3-2.1-2.5-2.1c-1.4,0-2.3,0.8-2.6,2.1H76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.9,955.2v8.6h-1.9v-1.2c-0.7,0.9-1.7,1.5-3,1.5c-2.3,0-4.3-2-4.3-4.5c0-2.6,1.9-4.5,4.3-4.5 c1.3,0,2.3,0.5,3,1.4v-1.2H88.9z M87.1,959.5c0-1.6-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.1-2.7,2.7c0,1.6,1.2,2.7,2.7,2.7 C85.9,962.3,87.1,961.1,87.1,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.1,951.3H93v12.5h-1.9V951.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,955.2l-3.3,8.6h-2.1l-3.3-8.6h2l2.4,6.5l2.4-6.5H102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.2,955.2h1.9v8.9c0,2.4-1.2,3.5-3.5,3.3v-1.8c1.1,0.1,1.7-0.3,1.7-1.5V955.2z M104,952.8 c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2C104.5,954,104,953.4,104,952.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116,955.2l-3.3,8.8c-0.8,2.2-2.2,3.3-4.2,3.2v-1.7c1.2,0.1,1.9-0.5,2.3-1.7l0.1-0.2l-3.6-8.4h2l2.6,6.2 l2.2-6.2H116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C210.4,934.9,211.9,936.6,211.9,938.7z M210.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C209.8,941.6,210.9,940.3,210.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.5,940.8h-3.4l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6h-1.1L219.5,940.8z M219.2,939.9l-1.4-3.8l-1.4,3.8 H219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L226.4,939.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.1,940.1c0,1.5-1.1,2.6-2.6,2.6c-1.5,0-2.6-1.1-2.6-2.6c0-0.6,0.2-1.1,0.5-1.5l2.5-3.7h1.2l-1.8,2.7 c0.1,0,0.2,0,0.4,0C241,937.5,242.1,938.6,242.1,940.1z M241.1,940.1c0-1-0.7-1.6-1.6-1.6c-1,0-1.6,0.6-1.6,1.6s0.7,1.6,1.6,1.6 C240.4,941.7,241.1,941,241.1,940.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.3,934.9v0.9l-2.8,6.7h-1.1l2.8-6.7h-3.7v-1H249.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C57.4,934.9,58.9,936.6,58.9,938.7z M57.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C56.8,941.6,57.9,940.3,57.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70,940.8l0.9-0.5c0.3,0.8,0.9,1.4,2,1.4c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.7-1-1.8-1.4 c-1.2-0.4-2.4-0.8-2.4-2.2c0-1.4,1.1-2.2,2.4-2.2c1.3,0,2.2,0.7,2.6,1.7l-0.8,0.5c-0.3-0.7-0.8-1.2-1.7-1.2 c-0.8,0-1.4,0.4-1.4,1.1c0,0.7,0.5,1,1.6,1.3c1.3,0.4,2.6,0.8,2.6,2.3c0,1.3-1.1,2.2-2.6,2.2C71.5,942.7,70.4,941.9,70,940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80,934.9v7.6h-1v-7.6H80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.3,939.2c0,1.9-1.4,3.5-3.7,3.5c-2.4,0-4-1.8-4-4c0-2.2,1.7-4,4-4c1.4,0,2.7,0.8,3.3,1.8l-0.9,0.5 c-0.4-0.8-1.4-1.4-2.4-1.4c-1.8,0-3,1.3-3,3c0,1.7,1.2,3,3,3c1.6,0,2.5-0.9,2.7-2h-2.8v-0.9h3.8V939.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.6,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.1,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.2,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C117.6,934.9,119.2,936.6,119.2,938.7z M118.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C117.1,941.6,118.2,940.3,118.2,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.2,940.4c0,1.2-1,2.2-2.2,2.2h-3.3v-7.6h3c1.2,0,2.1,0.9,2.1,2.1c0,0.7-0.3,1.2-0.8,1.6 C132.7,938.9,133.2,939.5,133.2,940.4z M128.7,935.8v2.3h2c0.6,0,1.1-0.5,1.1-1.2c0-0.6-0.5-1.2-1.1-1.2H128.7z M132.2,940.3 c0-0.7-0.5-1.2-1.2-1.2h-2.3v2.5h2.3C131.7,941.6,132.2,941,132.2,940.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L139.4,939.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.2,958.1c0,3.5-2.5,6.2-5.9,6.2h-4.9v-12.4h4.9C213.7,951.9,216.2,954.6,216.2,958.1z M214.3,958.1 c0-2.5-1.6-4.2-4-4.2h-2.8v8.5h2.8C212.7,962.3,214.3,960.5,214.3,958.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.5,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C219.6,964.5,217.5,962.5,217.5,959.9z M224.9,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 S224.9,961.5,224.9,959.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.5,955.4v8.4c0,2.8-2.2,4.2-4.5,4.2c-1.9,0-3.5-0.7-4.2-2.1l1.6-1c0.4,0.8,1,1.4,2.6,1.4 c1.6,0,2.6-0.9,2.6-2.4v-1.1c-0.7,1-1.7,1.5-3.1,1.5c-2.5,0-4.5-2-4.5-4.6s2-4.6,4.5-4.6c1.4,0,2.4,0.6,3.1,1.5v-1.3H237.5z  M235.6,959.8c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8C234.4,962.6,235.6,961.4,235.6,959.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M846.1,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C844.6,934.9,846.1,936.6,846.1,938.7z M845.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C844.1,941.6,845.2,940.3,845.2,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M849.3,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C851,942.7,849.3,940.9,849.3,938.7z  M856.1,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C854.9,941.7,856.1,940.4,856.1,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M859.8,934.9h1.1l1.7,6.3l1.9-6.3h1l1.9,6.3l1.7-6.3h1.1l-2.2,7.6h-1.2l-1.8-6.1l-1.8,6.1H862L859.8,934.9z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M879.3,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H879.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M887.5,941.6v1h-4.3v-7.6h1v6.7H887.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M889.9,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C891.6,942.7,889.9,940.9,889.9,938.7z  M896.8,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C895.5,941.7,896.8,940.4,896.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M905.4,940.8H902l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6H906L905.4,940.8z M905.1,939.9l-1.4-3.8l-1.4,3.8 H905.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M916.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C915.4,934.9,916.9,936.6,916.9,938.7z M915.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C914.9,941.6,915.9,940.3,915.9,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M926.5,935.8v2.5h3.2v1h-3.2v3.2h-1v-7.6h4.4v1H926.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M936.2,939.6h-1.8v2.9h-1v-7.6h3c1.3,0,2.4,1.1,2.4,2.4c0,1-0.7,1.9-1.6,2.2l1.8,3.1h-1.1L936.2,939.6z  M934.4,938.7h2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4h-2V938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M941.9,938.7c0-2.2,1.7-4,3.9-4c2.2,0,4,1.8,4,4c0,2.2-1.7,4-4,4C943.6,942.7,941.9,940.9,941.9,938.7z  M948.8,938.7c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C947.5,941.7,948.8,940.4,948.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M960.4,942.5h-1v-6l-2.5,4.2h-0.1l-2.5-4.1v5.9h-1v-7.6h1.1l2.4,4l2.4-4h1.1V942.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M839.3,952.9c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 C839.9,954.1,839.3,953.6,839.3,952.9z M839.6,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M843.7,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M847.8,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M852,951.4h1.9v12.9H852V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M864,955.4v8.9h-1.9v-1.1c-0.6,0.9-1.5,1.4-2.7,1.4c-2,0-3.4-1.3-3.4-3.6v-5.4h1.9v5.2c0,1.3,0.8,2.1,2,2.1 c1.3,0,2.2-0.7,2.2-2.5v-4.7H864z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M872.6,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C867.9,959.5,872.6,958.5,872.6,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M876.7,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8H876.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M885.4,955.3v2.1c-1.3-0.1-2.7,0.5-2.7,2.5v4.5h-1.9v-8.9h1.9v1.5C883.2,955.7,884.2,955.3,885.4,955.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M895.3,955.4v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5v-1.3H895.3z M893.4,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C892.2,962.7,893.4,961.5,893.4,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M900.3,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8H900.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M903.9,952.9c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 C904.5,954.1,903.9,953.6,903.9,952.9z M904.2,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M907.8,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C909.9,964.5,907.8,962.5,907.8,959.9z M915.3,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C914.1,962.7,915.3,961.5,915.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M927,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7h-1.9v-8.9h1.9v1.1 c0.6-0.9,1.5-1.4,2.7-1.4C925.5,955.2,927,956.6,927,958.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M935.5,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C930.7,959.5,935.5,958.5,935.5,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M936.8,963.2c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C937.4,964.5,936.8,963.9,936.8,963.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M940.3,959.9c0-2.6,2-4.7,4.7-4.7c1.7,0,3.2,0.9,3.9,2.3l-1.6,1c-0.4-0.8-1.3-1.4-2.3-1.4 c-1.6,0-2.7,1.2-2.7,2.8c0,1.6,1.2,2.8,2.7,2.8c1.1,0,1.9-0.5,2.4-1.4l1.6,0.9c-0.7,1.4-2.2,2.3-4,2.3 C942.3,964.5,940.3,962.5,940.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M949.7,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C951.8,964.5,949.7,962.5,949.7,959.9z M957.2,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 S957.2,961.5,957.2,959.9z"
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10_",
    className: "st3",
    x1: 188.5,
    y1: 784.2,
    x2: 200,
    y2: 784.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st4",
    d: "M495.2,625.8c2.9-17.4,9.8-37.4,18-54.1c-11.4,18.6-21.7,45.1-25.4,67.5 c-5.7,34.1-3.8,65.4,4.9,85.3l5.2-18.8C491.1,685.8,490,657,495.2,625.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st5",
    d: "M255.4,454.2c-28.6-2-29.6,31-24.6,53c2,12-11,19-16.9,28.2c-2.5,4-4.8,8.7-6,14.7 c-3.3,15.9,6.1,29.4,7.6,43.9c0.4,3.6,0.3,7.3-0.6,11.1c-1.1,4.1-3.1,8.1-5.1,12.1c-16,18-42,39-24,63c3.3,4.2,6.9,7.9,10.8,11.2 c31.2,26.8,78.2,24.8,114.2,7.8c13-7,26-17,29-32c2-16-5-31-15.7-41.6c-3.2-3.5-6.7-6.8-10.3-9.7c-2.6-4-4.2-7.8-5-11.5 c-1.9-9.2,1-17.8,3.8-26.5c1.4-4.3,2.7-8.7,3.4-13.2c3.8-22.6-18.2-36.6-30.2-52.6c-5-7-3-16-1-24c4-19-11-35-28.9-34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st3",
    d: "M259.9,548.9c-4.6,21.7-5.6,43-5,64.3c0.2,5.3,13.9,94,5.1,132.8c-0.2,5.6-0.2,8.9-0.2,8.9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_45_",
    className: "st3",
    x1: 274.8,
    y1: 632.8,
    x2: 259.9,
    y2: 654.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st6",
    d: "M283.8,787.2h-46c-0.6,0-1.1-0.4-1.2-1l-11.8-49.8h72L285,786.3 C284.9,786.8,284.4,787.2,283.8,787.2z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_47_",
    className: "st7",
    x1: 232,
    y1: 764,
    x2: 289.6,
    y2: 764
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_48_",
    className: "st7",
    x1: 232.9,
    y1: 767.6,
    x2: 288.7,
    y2: 767.6
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_23_",
    className: "st3",
    x1: 503.4,
    y1: 773,
    x2: 503.4,
    y2: 784
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_69_",
    className: "st5",
    cx: 190.3,
    cy: 589.2,
    rx: 10.7,
    ry: 17.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_74_",
    x: 789.4,
    y: 670.2,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 712.1226 -364.7542)",
    className: "st5",
    width: 14,
    height: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_119_",
    x: 725.1,
    y: 383,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 487.6996 -402.4377)",
    className: "st5",
    width: 9,
    height: 9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_76_",
    className: "st8",
    x1: 227.1,
    y1: 256.3,
    x2: 227.1,
    y2: 270.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_78_",
    className: "st8",
    x1: 227.1,
    y1: 288.7,
    x2: 227.1,
    y2: 303
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_80_",
    className: "st8",
    x1: 206.8,
    y1: 268,
    x2: 219.2,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_79_",
    className: "st8",
    x1: 235,
    y1: 284.2,
    x2: 247.4,
    y2: 291.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_83_",
    className: "st8",
    x1: 206.8,
    y1: 291.3,
    x2: 219.2,
    y2: 284.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_82_",
    className: "st8",
    x1: 235,
    y1: 275.1,
    x2: 247.4,
    y2: 268
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_93_",
    className: "st8",
    x1: 853.1,
    y1: 317.4,
    x2: 853.1,
    y2: 327.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_92_",
    className: "st8",
    x1: 853.1,
    y1: 339.9,
    x2: 853.1,
    y2: 349.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_88_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_90_",
    className: "st8",
    x1: 839.1,
    y1: 325.5,
    x2: 847.7,
    y2: 330.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_89_",
    className: "st8",
    x1: 858.6,
    y1: 336.8,
    x2: 867.2,
    y2: 341.7
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_87_",
    className: "st8",
    x1: 839.1,
    y1: 341.7,
    x2: 847.7,
    y2: 336.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_86_",
    className: "st8",
    x1: 858.6,
    y1: 330.5,
    x2: 867.2,
    y2: 325.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_84_",
    className: "st6",
    cx: 776.5,
    cy: 464.8,
    r: 15.1
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_103_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_100_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_102_",
    className: "st8",
    x1: 776.5,
    y1: 442.8,
    x2: 776.5,
    y2: 454.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_101_",
    className: "st8",
    x1: 776.5,
    y1: 474.6,
    x2: 776.5,
    y2: 486.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_99_",
    className: "st8",
    x1: 757.5,
    y1: 453.8,
    x2: 768,
    y2: 459.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_98_",
    className: "st8",
    x1: 785.1,
    y1: 469.7,
    x2: 795.6,
    y2: 475.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_94_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_96_",
    className: "st8",
    x1: 757.5,
    y1: 476.4,
    x2: 768,
    y2: 469.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_95_",
    className: "st8",
    x1: 785.1,
    y1: 459.8,
    x2: 795.6,
    y2: 453.8
  })))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_106_",
    className: "st9",
    x1: 550.5,
    y1: 140.9,
    x2: 550.5,
    y2: 155.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_105_",
    className: "st9",
    x1: 557.8,
    y1: 148.2,
    x2: 543.2,
    y2: 148.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_110_",
    className: "st9",
    x1: 889.7,
    y1: 655.1,
    x2: 889.7,
    y2: 669.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_109_",
    className: "st9",
    x1: 897,
    y1: 662.5,
    x2: 882.3,
    y2: 662.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_107_",
    className: "st9",
    x1: 375.2,
    y1: 396,
    x2: 375.2,
    y2: 405
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_63_",
    className: "st9",
    x1: 379.7,
    y1: 400.5,
    x2: 370.7,
    y2: 400.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_108_",
    x: 328.3,
    y: 468.4,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 432.3811 -97.0651)",
    className: "st6",
    width: 10,
    height: 10
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_111_",
    className: "st9",
    x1: 112.1,
    y1: 431.2,
    x2: 138.5,
    y2: 431.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_22_",
    className: "st9",
    x1: 147.5,
    y1: 431.2,
    x2: 157.6,
    y2: 431.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_113_",
    className: "st9",
    x1: 126.8,
    y1: 444,
    x2: 156,
    y2: 444
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_117_",
    className: "st9",
    x1: 684.2,
    y1: 555.1,
    x2: 710.5,
    y2: 555.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_116_",
    className: "st9",
    x1: 719.5,
    y1: 555.1,
    x2: 729.6,
    y2: 555.1
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_115_",
    className: "st9",
    x1: 698.8,
    y1: 565.8,
    x2: 728.1,
    y2: 565.8
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_66_",
    className: "st3",
    x1: 765,
    y1: 784.2,
    x2: 806.3,
    y2: 784.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_30_",
    className: "st3",
    x1: 221,
    y1: 784.2,
    x2: 303.7,
    y2: 784.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_16_",
    className: "st6",
    cx: 700.5,
    cy: 192.7,
    r: 51.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_33_",
    className: "st6",
    cx: 752.2,
    cy: 151.7,
    r: 51.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_123_",
    className: "st6",
    cx: 823.9,
    cy: 170.2,
    r: 47.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_126_",
    className: "st6",
    cx: 752.2,
    cy: 222,
    r: 51.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_124_",
    className: "st6",
    cx: 807,
    cy: 222,
    r: 34.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st6",
    d: "M698.8,327.6c0,7.8-2,12.5-9.8,12.5s-14.2-3-14.2-10.8c0-7.8,4.1-14.8,12-14.8 C694.7,314.5,698.8,319.8,698.8,327.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st6",
    d: "M726.9,288.7c0,11.8-2.9,18.8-14.7,18.8S691,303,691,291.2s9.5-21.3,21.3-21.3 S726.9,277,726.9,288.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st0",
    d: "M717,640.2c0.2,2.7,0.3,5.4,0.3,8.1c0,55.9-45,101.3-100.5,101.3c-46.6,0-85.8-32-97.2-75.4 c4.1,52.1,47.4,93.2,100.2,93.2c55.5,0,100.5-45.3,100.5-101.3C720.4,657.1,719.2,648.5,717,640.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M717,640.2c0.2,2.7,0.3,5.4,0.3,8.1c0,55.9-45,101.3-100.5,101.3c-46.6,0-85.8-32-97.2-75.4 c4.1,52.1,47.4,93.2,100.2,93.2c55.5,0,100.5-45.3,100.5-101.3C720.4,657.1,719.2,648.5,717,640.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st0",
    d: "M541.3,549.2c-17-7.6-46.6,48.4-53.5,90c-5.7,34.1-3.8,65.4,4.9,85.3L541.3,549.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M541.3,549.2c-17-7.6-46.6,48.4-53.5,90c-5.7,34.1-3.8,65.4,4.9,85.3L541.3,549.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st0",
    d: "M593.7,549.2c17-7.6,46.6,48.4,53.5,90c5.7,34.1,3.8,65.4-4.9,85.3L593.7,549.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st4",
    d: "M639.9,625.8c-2.9-17.4-9.8-37.4-18-54.1c11.4,18.6,21.7,45.1,25.4,67.5 c5.7,34.1,3.8,65.4-4.9,85.3l-5.2-18.8C644,685.8,645,657,639.9,625.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st3",
    d: "M593.7,549.2c17-7.6,46.6,48.4,53.5,90c5.7,34.1,3.8,65.4-4.9,85.3L593.7,549.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M645.3,732c-1.1-16.6-44.3-196.8-56-205.8h-21.1h-21.7c-11.7,9-55,189.1-56,205.8 c-1.3,20.7-8.1,52.2,31.2,52.2h46.5h46C653.4,784.2,646.6,752.7,645.3,732z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st4",
    d: "M495.2,706.5c0,0-3.1,26.4,11.7,36.1c11.6,7.7,21.8,10.8,40.9,14.3c10.3,1.9,21.5,2.7,21.5,2.7 l1.2,23.7l-81.4,0.6c0,0-1.4-33.3,0.6-43.3C491.7,730.7,492.7,714.1,495.2,706.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st4",
    d: "M641.4,706.5c0,0,3.1,26.4-11.7,36.1c-11.6,7.7-21.8,10.8-40.9,14.3 c-10.3,1.9-21.5,2.7-21.5,2.7l-1.2,23.7l81.4,0.6c0,0,1.4-33.3-0.6-43.3C644.9,730.7,643.9,714.1,641.4,706.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st6",
    d: "M603.6,562.5c-2.5-0.7-4.9-1.1-7-1.1c-12.2,0-21.9,6.5-21.9,21.5c0,15.1,21.9,33,34.1,33 c3.3,0,6.4-0.9,9.2-2.5C613.1,595,608.1,577.2,603.6,562.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st6",
    d: "M511.1,692.1c13.5,0,24.5-13.3,24.5-29.7c0-15.7-10.1-28.6-22.9-29.6c-5,19.6-9.7,39-13.5,55.5 C502.8,690.7,506.8,692.1,511.1,692.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st4",
    d: "M543.4,530.5c0,0,7.1,5.7,23.4,5.7c13.2,0,24.8-5.7,24.8-5.7l-1-3.9l-46.5,0L543.4,530.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st3",
    d: "M645.3,732c-1.1-16.6-44.3-196.8-56-205.8h-21.1h-21.7c-11.7,9-55,189.1-56,205.8 c-1.3,20.7-8.1,52.2,31.2,52.2h46.5h46C653.4,784.2,646.6,752.7,645.3,732z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M643,454.2c-1.9-19.5-11.5-68.8-22.3-103.3c-17.2-55.1-37.4-69.5-49.1-71 c-1.2-0.2-3.8-0.2-3.8-0.2s-2.5,0-3.8,0.2c-11.7,1.4-31.8,15.7-49.1,70.9c-10.8,34.5-20.3,83.9-22.3,103.5 c-4.3,44,16.8,68.3,44.2,71.8c7.8,1,23.2,1,31,1c7.7,0,23.1,0,31-1C626.1,522.5,647.3,498.2,643,454.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_49_",
    className: "st4",
    cx: 567.8,
    cy: 479.6,
    rx: 18.9,
    ry: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st4",
    d: "M550.5,285.5c0,0-9,33.9-27.8,43.7c4.8-10.8,11.3-23.7,11.3-23.7S545.2,287,550.5,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st4",
    d: "M571.6,280c0,0,24.4,42,44.7,58.1c0,0-4.6-29.8-9.1-38.8S580.7,277.2,571.6,280z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st6",
    d: "M519.8,441.3c39.3-16.9,62.8-50.2,52.4-74.3c-7.3-16.9-29.3-24.8-55.3-22.2 c-0.6,1.9-1.3,3.9-1.9,6c-10,32-18.9,76.7-21.7,98.6C501.9,447.8,510.9,445.2,519.8,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st3",
    d: "M624.1,487.1c-11.2,16.3-35.7,27.3-61.8,27.3c-24.2,0-38.7-14.2-47.2-31.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_7_",
    className: "st2",
    cx: 567.8,
    cy: 477,
    rx: 23.7,
    ry: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M697.9,777.9c-15.2-14.3-44.4-21.4-72.9-19.2c-24.4,1.8-42.5,10.1-49.6,21.1 c-1.2,1.9,0.3,4.4,2.6,4.4l115.5,0C698,784.2,700.7,780.5,697.9,777.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st4",
    d: "M697.1,777.7c-0.3,0.1-0.7,0.2-1.1,0.2l-115.5,0c-1.4,0-2.6-0.3-3.5-0.9 c-0.3,0.3-0.7,0.6-1,0.9c-2.8,2.6-0.1,6.3,4.5,6.3l115.5,0c2.3,0,3.8-2.6,2.6-4.4C698.1,779,697.6,778.3,697.1,777.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st3",
    d: "M697.9,777.9c-15.2-14.3-44.4-21.4-72.9-19.2c-24.4,1.8-42.5,10.1-49.6,21.1 c-1.2,1.9,0.3,4.4,2.6,4.4l115.5,0C698,784.2,700.7,780.5,697.9,777.9z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_8_",
    className: "st3",
    x1: 635.4,
    y1: 773,
    x2: 635.4,
    y2: 784
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M441,777.9c15.2-14.3,44.4-21.4,72.9-19.2c24.4,1.8,42.5,10.1,49.6,21.1 c1.2,1.9-0.3,4.4-2.6,4.4l-115.5,0C440.9,784.2,438.2,780.5,441,777.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st4",
    d: "M562.1,777.7c-0.3,0.1-0.7,0.2-1.1,0.2l-115.5,0c-1.4,0-2.6-0.3-3.5-0.9 c-0.3,0.3-0.7,0.6-1,0.9c-2.8,2.6-0.1,6.3,4.5,6.3l115.5,0c2.3,0,3.8-2.6,2.6-4.4C563.1,779,562.6,778.3,562.1,777.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st3",
    d: "M441,777.9c15.2-14.3,44.4-21.4,72.9-19.2c24.4,1.8,42.5,10.1,49.6,21.1 c1.2,1.9-0.3,4.4-2.6,4.4l-115.5,0C440.9,784.2,438.2,780.5,441,777.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "M643,454.2c-1.9-19.5-11.5-68.8-22.3-103.3c-17.2-55.1-37.4-69.5-49.1-71 c-1.2-0.2-3.8-0.2-3.8-0.2s-2.5,0-3.8,0.2c-11.7,1.4-31.8,15.7-49.1,70.9c-10.8,34.5-20.3,83.9-22.3,103.5 c-4.3,44,16.8,68.3,44.2,71.8c7.8,1,23.2,1,31,1c7.7,0,23.1,0,31-1C626.1,522.5,647.3,498.2,643,454.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st0",
    d: "M569.8,279.5c0,0,34.9-7.4,44.5-2.9c9.9,4.6,27.8,39.7,20.4,53.4 C623.4,351,590.2,275,569.8,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st3",
    d: "M569.8,279.5c0,0,34.9-7.4,44.5-2.9c9.9,4.6,27.8,39.7,20.4,53.4 C623.4,351,590.2,275,569.8,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st0",
    d: "M504.3,285.8l48.3-1.4c0,0-44.8,48.2-65.5,58.6C466.4,353.4,487.6,285.7,504.3,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st3",
    d: "M504.3,285.8l48.3-1.4c0,0-44.8,48.2-65.5,58.6C466.4,353.4,487.6,285.7,504.3,285.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3_",
    className: "st2",
    cx: 548.7,
    cy: 387.5,
    rx: 5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6_",
    className: "st2",
    cx: 590.9,
    cy: 387.5,
    rx: 5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_57_",
    className: "st3",
    x1: 392.3,
    y1: 784.2,
    x2: 739,
    y2: 784.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    className: "st6",
    d: "M668.2,347c0,5.6-1.4,8.9-7,8.9s-10.1-2.1-10.1-7.7s4.5-10.1,10.1-10.1S668.2,341.4,668.2,347 z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st10",
    d: "M804.8,188c1.5-1.8,2.4-4.3,2.1-7c-0.5-4.2-6.2-6.3-8.6-6.8c-3.2-0.6-9.9,2.3-9.9,7.8 c0,0,0,0,0,0c0,1.3-1,2.4-2.3,2.4h-45.5c-1.3,0-2.3-1.1-2.3-2.3c0-1.2-0.2-2.5-0.8-3.8c-1.3-3-4.6-3.4-7.5-3.7 c-5-0.6-10.3,1.9-10.3,7.4c0,2.3,0.8,4.3,2.2,5.9c0.9,1.1,0.9,2.7,0,3.8c-1.5,1.8-2.4,4.3-2.1,7c0.5,4.2,4.5,6,8.3,6.4 c5,0.6,10.2-2,10.2-7.4c0,0,0,0,0,0c0-1.3,1-2.4,2.3-2.4h45.5c1.3,0,2.3,1.1,2.3,2.3c0,1.2,0.2,2.5,0.8,3.8c1.3,3,6,3.7,7.8,4.1 c3.2,0.6,9.9-2.3,9.9-7.8c0-2.3-0.8-4.3-2.2-5.9C803.9,190.7,803.9,189.1,804.8,188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.7be9f7565962490a22b99cfc73409f36.svg";
export { ForwardRef as ReactComponent };